import { createAction } from 'utils/redux'

export const setPlaybookType = (reportType) =>
  createAction({
    type: 'SET_PLAYBOOK_TYPE',
    reportType,
  })

export const setPreviewState = (isPreview) =>
  createAction({
    type: 'SET_PREVIEW_STATE',
    isPreview,
  })

export const setConnectedCalendars = (ids) =>
  createAction({
    type: 'SET_CONNECTED_CALENDARS',
    ids,
  })

export const setGeoTargetingDismissed = (playbookId) =>
  createAction({
    type: 'SET_GEO_TARGETING_DISMISSED',
    playbookId,
  })

export const setBotFlowMode = (botFlowMode) =>
  createAction({
    type: 'SET_BOT_FLOW_MODE',
    botFlowMode,
  })
